<template>
    <div class="order-item-quantity" :class="qtyClassObject">
        <span>{{ quantity }}x</span>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";

    const props = defineProps<{
        quantity: number;
        quantityDigits?: number;
        indent?: boolean;
    }>();

    const qtyClassObject = computed(() => {
        return {
            "qty-1": props.quantityDigits == 1,
            "qty-2": props.quantityDigits == 2,
            "qty-3": props.quantityDigits == 3,
            "qty-4": props.quantityDigits == 4,
            indent: props.indent,
        };
    });
</script>

<style scoped lang="scss">
    @use "./../../../assets/styles/scss/shared/_colors.scss";
    @use "./../../../assets/styles/scss/shared/_variables.scss";

    .order-item-quantity {
        font-size: 16px;
        color: var(--colorPrimary);
        font-weight: 600;
        text-align: right;
        padding-right: 0.4em;
        transition: flex-basis 0.4s variables.$easeOutExpo;
        flex-basis: auto;
        position: relative;

        &[class*="qty-"] > span {
            position: absolute;
            right: 0.4em;
        }

        &.indent {
            padding-left: 0.7em;

            &.qty-1 {
                flex-basis: 2.25em;
            }

            &.qty-2 {
                flex-basis: 2.85em;
            }

            &.qty-3 {
                flex-basis: 3.45em;
            }

            &.qty-4 {
                flex-basis: 4.05em;
            }
        }

        &.qty-1 {
            flex-basis: 1.25em;
        }

        &.qty-2 {
            flex-basis: 1.85em;
        }

        &.qty-3 {
            flex-basis: 2.45em;
        }

        &.qty-4 {
            flex-basis: 3.05em;
        }
    }
</style>
